(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cro102-ingredients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rh-garlic-ingredients')) {
    customElements.define('rh-garlic-ingredients', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.tabs = [...this.querySelectorAll('[data-tab]')];
        this.panels = [...this.querySelectorAll('[data-panel]')];
        if (!this.tabs.length) return;
        this.querySelector('[data-tabs]').setAttribute('role','tablist');
        for (const [index,tab] of this.tabs.entries()) {
          tab.setAttribute('role','tab');
          this.panels[index].setAttribute('role','tabpanel');
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click',()=>this.select(index),options);
          tab.addEventListener('keydown',event=>{
            let target;
            if(event.key==='ArrowRight') target=(index+1)%this.tabs.length;
            if(event.key==='ArrowLeft') target=(index+this.tabs.length-1)%this.tabs.length;
            if(event.key==='Home') target=0;
            if(event.key==='End') target=this.tabs.length-1;
            if(target===undefined) return;
            event.preventDefault(); this.select(target); this.tabs[target].focus();
          },options);
        }
        this.setAttribute('data-enhanced',''); this.select(0);
        this.addEventListener('shopify:block:select',event=>{
          const panel=event.target.closest('[data-panel]');
          const index=this.panels.indexOf(panel);
          if(index>=0) this.select(index);
        },options);
      }
      disconnectedCallback() { this.controller?.abort(); }
      select(index) {
        for(const [i,tab] of this.tabs.entries()) {
          tab.setAttribute('aria-selected',String(i===index));
          tab.tabIndex=i===index?0:-1;
          this.panels[i].hidden=i!==index;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cro102-marquee"] && !Shopify.designMode) return;
  try {
    
class RHGarlicMarquee extends HTMLElement{
 #controller;
 connectedCallback(){this.#controller?.abort();this.#controller=new AbortController();const button=this.querySelector('button');if(!button)return;button.hidden=false;button.addEventListener('click',()=>{const paused=this.toggleAttribute('data-paused');button.setAttribute('aria-pressed',String(paused));button.textContent=paused?'▶':'Ⅱ';},{signal:this.#controller.signal});}
 disconnectedCallback(){this.#controller?.abort();}
}
if(!customElements.get('rh-garlic-marquee'))customElements.define('rh-garlic-marquee',RHGarlicMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-garlic-feedback"] && !Shopify.designMode) return;
  try {
    
class RHFeedback extends HTMLElement {
  connectedCallback(){
    this.observer?.disconnect();
    if(matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window)||this.hasAttribute('data-seen'))return;
    this.setAttribute('data-ready','');
    this.observer=new IntersectionObserver(entries=>{if(!entries.some(entry=>entry.isIntersecting))return;this.observer.disconnect();this.setAttribute('data-seen','');const start=performance.now();const numbers=[...this.querySelectorAll('[data-value]')];const tick=now=>{if(!this.isConnected)return;const progress=Math.min(1,(now-start)/850);for(const number of numbers)number.textContent=Math.round(Number(number.dataset.value)*(1-Math.pow(1-progress,3)));if(progress<1)this.frame=requestAnimationFrame(tick);};this.frame=requestAnimationFrame(tick);},{threshold:.15});this.observer.observe(this);
  }
  disconnectedCallback(){this.observer?.disconnect();cancelAnimationFrame(this.frame);for(const number of this.querySelectorAll('[data-value]'))number.textContent=number.dataset.value;}
}
if(!customElements.get('rh-feedback'))customElements.define('rh-feedback',RHFeedback);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-garlic-ingredients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rh-garlic-ingredients')) {
    customElements.define('rh-garlic-ingredients', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.tabs = [...this.querySelectorAll('[data-tab]')];
        this.panels = [...this.querySelectorAll('[data-panel]')];
        if (!this.tabs.length) return;
        this.querySelector('[data-tabs]').setAttribute('role','tablist');
        for (const [index,tab] of this.tabs.entries()) {
          tab.setAttribute('role','tab');
          this.panels[index].setAttribute('role','tabpanel');
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click',()=>this.select(index),options);
          tab.addEventListener('keydown',event=>{
            let target;
            if(event.key==='ArrowRight') target=(index+1)%this.tabs.length;
            if(event.key==='ArrowLeft') target=(index+this.tabs.length-1)%this.tabs.length;
            if(event.key==='Home') target=0;
            if(event.key==='End') target=this.tabs.length-1;
            if(target===undefined) return;
            event.preventDefault(); this.select(target); this.tabs[target].focus();
          },options);
        }
        this.setAttribute('data-enhanced',''); this.select(0);
        this.addEventListener('shopify:block:select',event=>{
          const panel=event.target.closest('[data-panel]');
          const index=this.panels.indexOf(panel);
          if(index>=0) this.select(index);
        },options);
      }
      disconnectedCallback() { this.controller?.abort(); }
      select(index) {
        for(const [i,tab] of this.tabs.entries()) {
          tab.setAttribute('aria-selected',String(i===index));
          tab.tabIndex=i===index?0:-1;
          this.panels[i].hidden=i!==index;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-garlic-journey"] && !Shopify.designMode) return;
  try {
    
class RHGarlicJourney extends HTMLElement {
  #observer;
  #controller;
  #frame;
  connectedCallback() {
    this.#observer?.disconnect();
    this.#controller?.abort();
    this.#controller = new AbortController();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    this.setAttribute('data-enhanced','');
    const track = this.querySelector('.rh-journey__track');
    const update = () => {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => {
        const rect = track.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, (window.innerHeight * .7 - rect.top) / rect.height));
        this.style.setProperty('--rh-progress', progress);
      });
    };
    window.addEventListener('scroll', update, { passive:true, signal:this.#controller.signal });
    window.addEventListener('resize', update, { passive:true, signal:this.#controller.signal });
    update();
    this.#observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-seen');
        this.#observer.unobserve(entry.target);
      }
    }, { threshold:.2 });
    for (const stage of this.querySelectorAll('.rh-journey__stage')) this.#observer.observe(stage);
  }
  disconnectedCallback() { this.#observer?.disconnect(); this.#controller?.abort(); cancelAnimationFrame(this.#frame); }
}
if (!customElements.get('rh-garlic-journey')) customElements.define('rh-garlic-journey', RHGarlicJourney);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-garlic-marquee"] && !Shopify.designMode) return;
  try {
    
class RHGarlicMarquee extends HTMLElement{
 #controller;
 connectedCallback(){this.#controller?.abort();this.#controller=new AbortController();const button=this.querySelector('button');if(!button)return;button.hidden=false;button.addEventListener('click',()=>{const paused=this.toggleAttribute('data-paused');button.setAttribute('aria-pressed',String(paused));button.textContent=paused?'▶':'Ⅱ';},{signal:this.#controller.signal});}
 disconnectedCallback(){this.#controller?.abort();}
}
if(!customElements.get('rh-garlic-marquee'))customElements.define('rh-garlic-marquee',RHGarlicMarquee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-garlic-routine"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rh-garlic-routine')) {
    customElements.define('rh-garlic-routine', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = [...this.querySelectorAll('[data-rh-tab]')];
        this.panels = [...this.querySelectorAll('[data-rh-panel]')];
        if (!this.tabs.length) return;
        this.querySelector('[data-rh-tabs]').setAttribute('role', 'tablist');
        this.tabs.forEach((tab, index) => {
          tab.setAttribute('role', 'tab');
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', () => this.select(index), options);
          tab.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowRight') target = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') target = (index + this.tabs.length - 1) % this.tabs.length;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = this.tabs.length - 1;
            if (target !== undefined) { event.preventDefault(); this.select(target); this.tabs[target].focus(); }
          }, options);
        });
        this.setAttribute('data-enhanced', '');
        this.select(0);
        this.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[data-rh-panel]');
          if (panel) this.select(Number(panel.dataset.rhPanel));
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
      select(index) {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.panels[i].hidden = i !== index;
        });
        const points = [[0,0],[160,-85],[320,-170],[505,-222]];
        const point = points[index] || points[0];
        this.querySelector('[data-rh-orb]').style.transform = `translate(${point[0]}px, ${point[1]}px)`;
        this.querySelector('[data-rh-caption]').textContent = this.panels[index].dataset.caption;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-garlic-sale"] && !Shopify.designMode) return;
  try {
    
class RHGarlicSale extends HTMLElement {
 #interval; #observer;
 connectedCallback(){
  clearInterval(this.#interval); this.#observer?.disconnect();
  const preview=this.dataset.mode==='preview';
  let end=Date.parse(this.dataset.endsAt || '');
  if(preview){
   const duration=(Number(this.dataset.minutes)||60)*60000;
   const key='rh-preview-countdown:'+this.dataset.key+':'+duration;
   try { const stored=Number(sessionStorage.getItem(key)); end=stored || Date.now()+duration; if(!stored)sessionStorage.setItem(key,String(end)); } catch { end=Date.now()+duration; }
  }
  if(!Number.isFinite(end))return;
  const update=()=>{
   const remaining=Math.max(0,Math.ceil((end-Date.now())/1000));
   this.hidden=!preview && remaining===0;
   this.querySelector('[data-hours]').textContent=String(Math.floor(remaining/3600)).padStart(2,'0');
   this.querySelector('[data-minutes]').textContent=String(Math.floor(remaining/60)%60).padStart(2,'0');
   this.querySelector('[data-seconds]').textContent=String(remaining%60).padStart(2,'0');
   if(!remaining)clearInterval(this.#interval);
  };
  update(); this.#interval=setInterval(update,1000);
  this.#observer=new ResizeObserver(()=>document.body.style.setProperty('--rh-timer-height',this.getBoundingClientRect().height+'px'));
  this.#observer.observe(this);
 }
 disconnectedCallback(){clearInterval(this.#interval);this.#observer?.disconnect();}
}
if(!customElements.get('rh-garlic-sale'))customElements.define('rh-garlic-sale',RHGarlicSale);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-x-sr-tk-mechanism"] && !Shopify.designMode) return;
  try {
    
  function tkMechVideoInit() {
    var vids = document.querySelectorAll('video[data-tkmech-video], .tkmech__hub-video');
    if (!vids.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.play().catch(function () {}); }
        else { e.target.pause(); }
      });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tkMechVideoInit);
  } else {
    tkMechVideoInit();
  }
  document.addEventListener('shopify:section:load', tkMechVideoInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-x-sr-tk-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const el = document.querySelector('[data-tko-cd]');
    if (!el) return;
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const now = new Date();
      const end = new Date(now);
      end.setHours(24, 0, 0, 0);
      const s = Math.max(0, Math.floor((end - now) / 1000));
      el.textContent = `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
    };
    tick();
    setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-x-sr-tk-urgency"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Evergreen countdown to local midnight. No fake date is stored, so it can
    // never show a stale "expired" state to a shopper.
    const el = document.querySelector('[data-tku-cd]');
    if (el) {
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const now = new Date();
        const end = new Date(now);
        end.setHours(24, 0, 0, 0);
        const s = Math.max(0, Math.floor((end - now) / 1000));
        el.textContent = `${pad(Math.floor(s / 3600))}:${pad(Math.floor((s % 3600) / 60))}:${pad(s % 60)}`;
      };
      tick();
      setInterval(tick, 1000);
    }

    // Same cycling countdown as the buy-box timer (independent instance, same
    // math): remaining = cycle - ((now - anchor) mod cycle).
    const cd = document.querySelector('[data-tks-cd]');
    if (cd) {
      const days = parseInt(cd.getAttribute('data-days'), 10) || 7;
      let anchor = Date.parse(cd.getAttribute('data-anchor') + 'T00:00:00Z');
      if (Number.isNaN(anchor)) anchor = Date.UTC(2026, 8, 11);
      const cycle = days * 864e5;
      const unit = (n, w) => n + ' ' + w + (n === 1 ? '' : 's');
      const tickCd = () => {
        const e = ((Date.now() - anchor) % cycle + cycle) % cycle;
        const r = cycle - e;
        const d = Math.floor(r / 864e5), h = Math.floor((r % 864e5) / 36e5),
              m = Math.floor((r % 36e5) / 6e4), s = Math.floor((r % 6e4) / 1e3);
        cd.textContent = 'Offer ends in ' + unit(d, 'day') + ' ' + unit(h, 'hour') + ' ' + unit(m, 'minute') + ' ' + unit(s, 'second');
      };
      tickCd();
      setInterval(tickCd, 1000);
    }

    // Reveal the sticky bar only after the shopper has scrolled past the fold,
    // so it never covers the buy box it is meant to shortcut to.
    const bar = document.querySelector('[data-tks]');
    if (bar) {
      const onScroll = () => {
        if (window.scrollY > 600) {
          bar.removeAttribute('hidden');
        } else {
          bar.setAttribute('hidden', '');
        }
      };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-x-sr123-current-12"] && !Shopify.designMode) return;
  try {
    
(()=>{const started=Date.now();function update(){document.querySelectorAll('[data-offer-deadline]').forEach(box=>{const deadline=Date.parse(box.dataset.offerDeadline);const actual=Number.isFinite(deadline);const seconds=Math.max(0,Math.floor(((actual?deadline:started+10800000)-Date.now())/1000));const clock=box.querySelector('[data-purchase-countdown]');const caption=box.querySelector('[data-countdown-caption]');clock.textContent=[Math.floor(seconds/3600),Math.floor(seconds%3600/60),seconds%60].map(v=>String(v).padStart(2,'0')).join(' : ');caption.textContent=actual?(seconds?'Offer countdown':'Offer ended'):'Countdown preview';});}update();setInterval(update,1000);document.addEventListener('shopify:section:load',update);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rh-x-sr123-offer-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  const key = 'sr123-offer-nine-minute-start';
  let start = Date.now();
  try { start = Number(sessionStorage.getItem(key)) || start; sessionStorage.setItem(key, String(start)); } catch (error) {}
  const tick = () => {
    const remaining = Math.max(0, 540 - Math.floor((Date.now() - start) / 1000));
    const value = [Math.floor(remaining / 60), remaining % 60].map(n => String(n).padStart(2, '0')).join(' : ');
    document.querySelectorAll('[data-sr123-offer-timer]').forEach(el => { el.textContent = value; });
  };
  tick(); setInterval(tick, 1000);
})();

  } catch(e) { console.error(e); }
})();
})();
